export const SHOW_ERROR = 'SHOW_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
export const SET_ERROR_MSG = 'SET_ERROR_MSG';
export const SHOW_ERROR_IN_MODAL = 'SHOW_ERROR_IN_MODAL';
export const SET_ERROR_MSG_IN_MODAL = 'SET_ERROR_MSG_IN_MODAL';
